export default "__VITE_ASSET__CFAM7$VC__"